import React, {useCallback, useState} from 'react';
import {Container} from "../../ui/Container";
import {Card, FormControlLabel, Switch} from "@mui/material";
import {makeStyles} from "@mui/styles";
import {useFormik} from "formik";
import {AppField} from "../../ui/AppField";
import {AppButton} from "../../ui/AppButton";
import {object, string} from "yup";
import {useI18n} from "../../../i18n/I18nContext";
import {useHistory, useParams} from "react-router";
import {useIntegrationsContext} from "../../../api/integrations/IntegrationsContext";
import {showError} from "../../../utils/NotificationUtils";
import {pathParams} from "path-params";
import {Routes} from "../../../constants/Routes";

const validationSchema = (translate: any) => object({
    label: string().required(translate("REQUIRED")),
    code: string().required(translate("REQUIRED")),
    description: string(),
    defaultValue: string(),
    type: string(),
    required: string(),
});


const useStyles = makeStyles(() => ({
    root: {
        padding: 24
    },
    cardRoot: {
        padding: 24,
        borderRadius: "16px !important" as any
    },
    formTitle: {
        fontSize: 18,
        lineHeight: "21px",
        fontWeight: 700,
        color: "#000",
        marginBottom: 16
    },
    fieldRoot: {
        marginBottom: 24
    }
}));


export function IntegrationAddAuthFields() {
    const classes = useStyles();
    const {translate} = useI18n();
    const params: any = useParams();
    const history = useHistory();
    const {IntegrationsApi} = useIntegrationsContext();
    const [required, setRequired] = useState<boolean>(false);


    const formik = useFormik({
        initialValues: {
            code: "",
            defaultValue: "",
            description: "",
            label: "",
            required: required,
            type: "STRING"
        },
        validationSchema: validationSchema(translate),
        onSubmit: (values) => handleSubmit(values),
    });

    const handleSubmit = useCallback((values) => {
        IntegrationsApi.createIntegrationAuthFields({
            params: {
                id: params.authId
            },
            data: {...values, required: required}
        }).then(res => {
            history.push(pathParams(Routes.IntegrationEditorAuth, {id: params.id, authId: params.authId}))
        }).catch(err => {
            showError(err)
        })
    }, [IntegrationsApi, required,history, params]);

    return (
        <div className={classes.root}>
            <Container>
                <Card className={classes.cardRoot}>
                    <h2 className={classes.formTitle}>Add Field</h2>
                    {/*<IntegrationCreateForm/>*/}
                    <form onSubmit={formik.handleSubmit}>
                        <div className={classes.fieldRoot}>
                            <AppField
                                fullWidth
                                required={true}
                                variant="outlined"
                                labelText="Label"
                                name="label"
                                id="label"
                                error={formik.touched.label && Boolean(formik.errors.label)}
                                helperText={formik.touched.label && formik.errors.label}
                                value={formik.values.label}
                                onChange={formik.handleChange}
                                helpDesc="Enter the field's friendly name for users."
                            />
                        </div>
                        <div className={classes.fieldRoot}>
                            <AppField
                                fullWidth
                                required={true}
                                variant="outlined"
                                labelText="Code"
                                name="code"
                                id="code"
                                error={formik.touched.code && Boolean(formik.errors.code)}
                                helperText={formik.touched.code && formik.errors.code}
                                value={formik.values.code}
                                onChange={formik.handleChange}
                                helpDesc="Add the field key, for example: api_key."
                            />
                        </div>
                        <div className={classes.fieldRoot}>
                            <FormControlLabel control={<Switch
                                checked={required}
                                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                    setRequired(event.target.checked);
                                }}
                                inputProps={{'aria-label': 'controlled'}}
                            />} label="Is this field required? Check if yes"/>

                        </div>
                        <div className={classes.fieldRoot}>
                            <AppField
                                fullWidth
                                variant="outlined"
                                labelText="Description"
                                name="description"
                                id="description"
                                error={formik.touched.description && Boolean(formik.errors.description)}
                                helperText={formik.touched.description && formik.errors.description}
                                value={formik.values.description}
                                onChange={formik.handleChange}
                                helpDesc="Explain to users what to include in this field, especially for API keys and other hard to find info. Include directions to find the data and links to your app settings or help docs"
                            />
                        </div>
                        <div className={classes.fieldRoot}>
                            <AppField
                                fullWidth
                                variant="outlined"
                                labelText="Default Value"
                                name="defaultValue"
                                id="defaultValue"
                                error={formik.touched.defaultValue && Boolean(formik.errors.defaultValue)}
                                helperText={formik.touched.defaultValue && formik.errors.defaultValue}
                                value={formik.values.defaultValue}
                                onChange={formik.handleChange}
                                helpDesc="Explain to users what to include in this field, especially for API keys and other hard to find info. Include directions to find the data and links to your app settings or help docs"
                            />
                        </div>
                        <div className={classes.fieldRoot}>
                            <AppField
                                fullWidth
                                variant="outlined"
                                labelText="Type"
                                name="type"
                                id="type"
                                error={formik.touched.type && Boolean(formik.errors.type)}
                                helperText={formik.touched.type && formik.errors.type}
                                value={formik.values.type}
                                onChange={formik.handleChange}
                                helpDesc="Explain to users what to include in this field, especially for API keys and other hard to find info. Include directions to find the data and links to your app settings or help docs"
                            />
                        </div>

                        <AppButton type="submit">Save</AppButton>
                    </form>
                </Card>
            </Container>
        </div>
    );
}



